import React from 'react'

import { Translate } from '@hozana/intl/Translate'
import type { TResponsiveProps } from '@hozana/styling/responsive'

import { Span } from 'elements/layout/Span'

import { P, TPProps } from '../text/P'

const responsiveProps = {
  m: 'margin',
  align: 'text-align',
} as const

export type TInputLabelProps = {
  htmlFor: string
  required?: boolean
} & TResponsiveProps<typeof responsiveProps> &
  TPProps

export const InputLabel: TFCC<TInputLabelProps> = ({
  children,
  required,
  htmlFor,
  m = '10px 0 5px',
  align = 'left',
  color = 'black70',
  ...otherProps
}) => (
  <P as="label" color={color} htmlFor={htmlFor} m={m} align={align} {...otherProps}>
    <Translate>{children}</Translate>
    {required && (
      <Span p="0 0 0 5px" color="red">
        *
      </Span>
    )}
  </P>
)
